// copied and edited from packages/ui/src/components/FlavorFinder/components/Answer/FlavorFinderAnswer.tsx
import type { FC } from "react";

import { ResponsiveImage } from "@ui/components/ResponsiveImage";

import type { FlavorFinderAnswerDetails } from "../../types/FlavorFinderTypes";
import { FlavorFinderAnswerButton } from "../Buttons/FlavorFinderButtons";

import styles from "./FlavorFinderAnswer.module.scss";

type FlavorFinderAnswerProps = {
  answer: FlavorFinderAnswerDetails;
  isActive: boolean;
  onAnswerClick: (id: string) => void;
};

export const FlavorFinderAnswer: FC<FlavorFinderAnswerProps> = ({ answer, isActive = false, onAnswerClick }) => {
  const {
    backgroundImage = "",
    tabletBackgroundImage = "",
    mobileBackgroundImage = "",
    title,
    subtitle,
    id = "",
  } = answer;

  return (
    <button
      type="button"
      className={styles.answerContainer}
      aria-pressed={isActive}
      aria-label={title}
      onClick={() => onAnswerClick(id)}
    >
      <FlavorFinderAnswerButton title={title} subtitle={subtitle} isActive={isActive} />
      <div className={styles.imageContainer}>
        <ResponsiveImage
          alt=""
          largeSrc={backgroundImage}
          mediumSrc={tabletBackgroundImage}
          smallSrc={mobileBackgroundImage}
          hideLoadingState
        />
      </div>
    </button>
  );
};
